import { qdfoodApi } from './constant';
import { IBanner } from '@type/banner';

export const BANNER_API = {
  urlGetBanner: `/banner/list`,
};

export default class bannerApi {
  static getBanner() {
    return qdfoodApi().get<IBanner[]>(BANNER_API.urlGetBanner, {
      params: {
        isDeleted: false,
      },
    });
  }
}
